import { forwardRef, useEffect, useRef } from "react";
import { Footer } from "../Footer/Footer";
import { Outlet } from "react-router-dom";
import Header from "@components/Header/Header";
import { useSelector } from "react-redux";
import type { RootState } from "@store/store";
import useNotifications from "@features/Notification/useNotifications";
import { SIDEBAR_EXPANDED_WIDTH_PX } from "@config/theme/tokens";
import Sidebar from "@components/Sidebar/Sidebar";
import ModalManager from "@components/common/ModalManager/ModalManager";

export const MainLayout = forwardRef<HTMLElement>(() => {
	const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);
	const { fetchInitial } = useNotifications();
	const fetchedRef = useRef(false);

	useEffect(() => {
		if (isAuthenticated && !fetchedRef.current) {
			fetchInitial();
			fetchedRef.current = true;
		}
	}, [isAuthenticated, fetchInitial]);

	return (
		<div className="min-h-screen flex flex-col bg-white">
			<Header />
			<Sidebar />
			<div className="flex flex-1 flex-col bg-white" style={{ marginLeft: `${SIDEBAR_EXPANDED_WIDTH_PX}px` }}>
				<main className="flex-1 bg-white p-2">
					<Outlet />
				</main>
			</div>
			<Footer />
			<ModalManager />
		</div>
	);
});
